<template>
    <div class="activeList" v-if="isShow">
        <el-dialog title="关联活动" :visible.sync="isShow">
            <div class="search">
                <el-input v-model.trim="eventname" placeholder="输入关联活动名称" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全民分销" name="first">
                    <list1 ref="list1" @getTable="_getTable"></list1>
                </el-tab-pane>
                <el-tab-pane label="助力砍价" name="second">
                    <list2 ref="list2" @getTable="_getTable"></list2>
                </el-tab-pane>
                <el-tab-pane label="品牌商零售" name="third">
                    <list3 ref="list3" @getTable="_getTable"></list3>
                </el-tab-pane>
            </el-tabs>
            <div class="btn">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="_getTable1">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import list1 from '@/views/vliveV2/components/list1'
    import list2 from '@/views/vliveV2/components/list2'
    import list3 from '@/views/vliveV2/components/list3'
    import {getRelEventListByLive} from 'api/vliveV2Api'
    import {mapGetters, mapActions} from 'vuex'
    import Page from 'base/page/page'
    export default {
        name: "activeList",
        data(){
            return{
                eventname:'', //活动名称
                activeName: 'first',
                isShow:false,
                radio:'',
                tableData:[],
                actvelist:[],
                total:0
            }
        },
        mounted(){

        },
        methods:{
            open(){
                this.isShow=true
            },
            _getTable(data){
                console.log(data)
                this.tableData = data
            },
            _getTable1(data){
                this.$emit('getTable',this.tableData)
                this.isShow=false;
                this.tableData = []
            },
            //搜索
            handleQuery(){
                this.eventname=this.eventname
                if(this.activeName=='first'){
                    this.$refs.list1.handleQuery(this.eventname);
                }else if(this.activeName=='second'){
                    this.$refs.list2.handleQuery(this.eventname);
                }else{
                    this.$refs.list3.handleQuery(this.eventname);
                }
            },
            //取消
            cancel(){
                this.isShow=false
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            ...mapActions([
                'setLoading',
            ])
        },
        components: {
            Page,list1,list2,list3
        },
        computed: {
            ...mapGetters([
                'page',
            ])
        },
    }
</script>

<style lang="scss">
    @import "~common/scss/base";
    @import "~common/scss/mixin";
    .activeList{
        .el-button{
            margin-bottom: 0!important;
        }
        .search{
            display: flex;
            justify-content: space-between;
            .el-input{
                width: 450px;
            }
        }
        .list_wrap{
            padding: 15px;
            border-bottom: 1px solid #eee;
            display: flex;
            align-items: center;
            .el-radio{
                margin-right: 0;
            }
            img{
                min-width: 74px;
                width: 74px;
                height: 42px;
                display: inline-block;
                margin-right: 10px;
                background: #eee;
            }
            .desp{
                line-height: 18px;
            }
        }
        .btn{
            text-align: center;
            padding-top: 20px;
            background: #fff;
            width: 600px;
            margin-left: -20px;
        }
    }

</style>
